import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/* ===============================
   ADMIN SPEAKER APIs
================================ */

/**
 * Create a new speaker
 * @param {{
 *   name: string,
 *   avatarUrl?: string,
 *   bio?: string
 * }} data
 */
export const createSpeaker = (data) =>
  api.post("/admin/speakers", data);

/**
 * Get all speakers
 */
export const getAllSpeakers = () =>
  api.get("/admin/speakers");

/**
 * Get speaker by ID
 * @param {number} speakerId
 */
export const getSpeakerById = (speakerId) =>
  api.get(`/admin/speakers/${speakerId}`);

/**
 * Update speaker
 * @param {number} speakerId
 * @param {{
 *   name: string,
 *   avatarUrl?: string,
 *   bio?: string
 * }} data
 */
export const updateSpeaker = (speakerId, data) =>
  api.put(`/admin/speakers/${speakerId}`, data);

/**
 * Delete speaker
 * @param {number} speakerId
 */
export const deleteSpeaker = (speakerId) =>
  api.delete(`/admin/speakers/${speakerId}`);

/**
 * Activate speaker
 * @param {number} speakerId
 */
export const activateSpeaker = (speakerId) =>
  api.put(`/admin/speakers/${speakerId}/activate`);

/**
 * Deactivate speaker
 * @param {number} speakerId
 */
export const deactivateSpeaker = (speakerId) =>
  api.put(`/admin/speakers/${speakerId}/deactivate`);


/** Fetch the active speakers */
export const fetchActiveSpeakers = () =>
  api.get("/admin/speakers/active-speakers");
